export default "__VITE_ASSET__BelxdBO1__"